import { useEffect } from 'react';

import { sendAgentHeartbeat } from '../api';

/**
 * Hook to send periodic heartbeat to backend to keep agent status active.
 *
 * @param identity - Agent identity (email)
 * @param phoneNumber - Agent phone number
 * @param isOnline - Whether agent is currently online (status === 'connected')
 *
 * Sends heartbeat every 5 minutes (300 seconds) to extend agent TTL.
 * Backend will expire agents after 10 minutes (600 seconds) of no heartbeat.
 */
export const useAgentHeartbeat = (
  identity: string | null,
  phoneNumber: string | null,
  isOnline: boolean,
) => {
  useEffect(() => {
    // Only send heartbeat when agent is online
    if (!identity || !phoneNumber || !isOnline) {
      return;
    }

    const sendHeartbeat = async() => {
      try {
        await sendAgentHeartbeat(identity);
      } catch (error) {
        console.error('Heartbeat failed:', error);
      }
    };

    // Send initial heartbeat immediately
    sendHeartbeat();

    // Send heartbeat every 5 minutes (300000ms)
    const interval = setInterval(sendHeartbeat, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [identity, phoneNumber, isOnline]);
};
